<template>
	<form @submit.prevent="submit">

		<div class="az_base_form_gr">
			<label class="az_base_lbl">{{ $t('name') }}</label>
			<input class="form-control az_base_inp"
			       type="text"
			       :class="{'is-invalid': $v.model.name.$error}"
			       v-model.trim="$v.model.name.$model">
		</div>
		<div class="custom-multiselect w-100 mb-3">
			<label class="az_base_lbl">{{ $tc('menu.office', 1) }}</label>
			<v-select
				:class="['custom-select-default custom-select-form', {'custom-select-default-is-invalid': $v.model.officeId.$error}]"
				label="name"
				v-model="$v.model.officeId.$model"
				:reduce="i => i.id"
				:options="offices">
				<template #open-indicator="{attributes}">
					<svg class="arrowD" v-bind="attributes" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
					     width="10px" height="10px"
					     viewBox="0 0 213.333 213.333" xml:space="preserve">
                        <polygon points="0,53.333 106.667,160 213.333,53.333"/>
                    </svg>
				</template>
			</v-select>
		</div>
		<div class="custom-multiselect w-100 mb-3">
			<label class="az_base_lbl">{{ $t('chief') }}</label>
			<v-select
				:class="['custom-select-default custom-select-form', {'custom-select-default-is-invalid': $v.model.officeId.$error}]"
				label="name"
				v-model="$v.model.chiefId.$model"
				:reduce="i => i.id"
				:getOptionLabel="getUsersOptionLabel"
				:options="employees">
				<template #open-indicator="{attributes}">
					<svg class="arrowD" v-bind="attributes" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
					     width="10px" height="10px"
					     viewBox="0 0 213.333 213.333" xml:space="preserve">
                        <polygon points="0,53.333 106.667,160 213.333,53.333"/>
                    </svg>
				</template>
			</v-select>
		</div>



		<button class="btn az_base_btn btn-primary" type="submit">
			<i class="fa fa-save mr-1"></i>
			{{ $t('save') }}
		</button>

	</form>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import notification from "@/plugins/vue-notification-config";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
	name: 'TheForm',
	components: {
		vSelect
	},
	props: {
		model: {
			type: Object,
			required: true,
		},
		edit: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			offices: [],
			employees: []
		}
	},
	validations() {
		let options = {
			model: {
				name: {
					required,
				},
				officeId: {
					required
				},
				chiefId: {
					required
				}
			}
		};

		return options;
	},
	methods: {
		submit() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				return;
			}

			this.$emit('emit:submit');
		},
		getUsersOptionLabel({lastName, firstName, middleName}) {
			return `${lastName} ${firstName} ${middleName}`
		},
		async getEmployees() {
			try {
				const {data: {data}} = await this.$api.get('employees')
				this.employees = data
			} catch (e) {
				notification.error()
			}
		},
		async getOffices() {
			try {
				const {data: {data}} = await this.$api.get('offices')
				this.offices = data
			} catch (e) {
				notification.error()
			}
		}
	},
	mounted() {
		this.getOffices()
		this.getEmployees()
	}
};
</script>